/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(
    private router: Router,
    private authService: AuthService,
    private platform: Platform
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isLoggedIn = this.checkLogin(state.url);
    if (isLoggedIn) {
      return true;
    }
    return false;
  }

  loginWithStrava() {
    console.log(this.platform.is('android'));
    console.log(this.platform.is('capacitor'));
    console.log(this.platform.is('cordova'));
    console.log(this.platform.is('desktop'));
    console.log(this.platform.is('electron'));
    console.log(this.platform.is('hybrid'));
    console.log(this.platform.is('ios'));
    console.log(this.platform.is('mobile'));
    console.log(this.platform.is('mobileweb'));
    console.log(this.platform.is('phablet'));
    console.log(this.platform.is('pwa'));
    console.log(this.platform.is('tablet'));

    const params = this.platform.is('android')
      ? 'client_id=54930&redirect_uri=https://runnergram/login&response_type=code&approval_prompt=auto&scope=profile:read_all,activity:read_all'
      : 'client_id=54930&redirect_uri=https://runnergram/login&response_type=code&approval_prompt=auto&scope=profile:read_all,activity:read_all';

    if (
      this.platform.is('android') ||
      this.platform.is('mobile') ||
      this.platform.is('mobileweb')
    ) {
      window.open('https://www.strava.com/oauth/mobile/authorize?' + params);
    } else {
      window.location.href = 'https://www.strava.com/oauth/authorize?' + params;
    }
  }

  private checkLogin(url: string): boolean {
    this.authService.redirectUrl = url;
    if (this.authService.isManuallyLoggedIn) {
      return true;
    }
    if (this.authService.isLoggedIn) {
      return true;
    }
    if (this.authService.needsNewToken) {
      this.authService.refreshToken().subscribe(
        (res) => {
          this.authService.updateToken(res);
          this.router.navigate([url]);
          return true;
        },
        () => {
          this.loginWithStrava();
          return false;
        }
      );
    } else {
      this.router.navigate(['/login']);
      return false;
    }

    //
  }
}
